import { use } from 'react';
import { useTranslation } from 'react-i18next';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import EcdIcon from 'assets/icons/ecd-icon.svg?react';

import ElectronicClientRecordAlertItem from 'features/residents/resident-settings/components/resident-setting-details/components/electronic-client-record-alert-accordion/components/electronic-client-record-alert-item/electronic-client-record-alert-item';
import useElectronicClientRecordAlertAccordion from 'features/residents/resident-settings/components/resident-setting-details/components/electronic-client-record-alert-accordion/hooks/electronic-client-record-alert-accordion-hook';
import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';
import styles from './electronic-client-record-alert-accordion.module.scss';

const ElectronicClientRecordAlertAccordion = (): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings', { keyPrefix: 'electronicClientRecordAlert' });
  const { isExpanded, toggleExpansion } = useElectronicClientRecordAlertAccordion();
  const {
    detailEditState: { currentResidentSetting },
  } = use(ResidentSettingsProviderContext);

  return (
    <Accordion expanded={isExpanded} disableGutters>
      <AccordionSummary
        className={styles.accordionSummaryContainer}
        expandIcon={<ExpandMore onClick={toggleExpansion} />}
        aria-label="Expand"
        aria-controls="additional-actions1-content"
      >
        <Grid
          className={styles.accordionSummaryContent}
          onClick={toggleExpansion}
          onKeyDown={(e) => e.key === 'Enter' && toggleExpansion()}
        >
          <EcdIcon className={styles.ecdIcon} />
          <Typography variant="h5">{t('title')}</Typography>
        </Grid>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: '0 0 8px 0', margin: 0 }}>
        <Typography variant="body1">{t('warnings')}</Typography>
        <div className={styles.accordionDetailsContent}>
          {currentResidentSetting?.electronicClientRecordClientResult?.clients?.[0].alerts.map((alert) => (
            <ElectronicClientRecordAlertItem key={alert.id} alert={alert} />
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default ElectronicClientRecordAlertAccordion;
